<template>
    <div>
            <a-form :form="supplier" layout="vertical" hide-required-mark>
                <div class="flex items-center mb15"><a-icon class="mr5" type="edit" theme="twoTone" /><div class="bold fs16" style="color:black">基本信息</div></div>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="名称" >
                            <a-input
                                v-model="supplier.name"
                                placeholder="请输入供应商名称"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="区域">
                            <a-cascader v-model="selectArea" :options="areaData" placeholder="请选择区域" @change="onChange"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="联系人">
                        <a-input
                            v-model="supplier.contact"
                            placeholder="请输入联系人"
                        />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="电话号码">
                            <a-input
                                v-model="supplier.phone"
                                placeholder="请输入电话号码"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="采购方式">
                            <a-select
                                label-in-value
                                v-model="selectPayWay"
                                style="width: 300px"
                                @change="handlePayWayChange"
                                placeholder="请选择采购方式"
                            >
                                <a-select-option value="1">
                                    现金采购
                                </a-select-option>
                                <a-select-option value="2">
                                    供应商欠款
                                </a-select-option>

                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="地址">
                            <a-input
                                v-model="supplier.address"
                                placeholder="请输入详细地址"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="flex items-center mb15"><a-icon class="mr5" type="property-safety" theme="twoTone" /><div class="bold fs16" style="color:black">银行信息</div></div>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="发票抬头">
                            <a-input
                                v-model="supplier.invoice_title"
                                placeholder="请输入发票抬头"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="纳税人识别号">
                            <a-input
                                v-model="supplier.tax_number"
                                placeholder="请输入纳税人识别号"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="行号">
                            <a-input
                                v-model="supplier.bank_code"
                                placeholder="请输入行号"
                            />
                        </a-form-item>
                       
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="银行账号">
                            <a-input
                                v-model="supplier.bank_account"
                                placeholder="请输入银行账号"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>   
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="开户行">
                            <a-input
                                v-model="supplier.opening_bank"
                                placeholder="请输入开户行"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="电话">
                            <a-input
                                v-model="supplier.account_phone"
                                placeholder="请输入电话"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>    
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="开户地址">
                            <a-input
                                v-model="supplier.opening_address"
                                placeholder="请输入开户地址"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>         
            </a-form>
            <div
                :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1,
                }"
            >
                <a-button :style="{ marginRight: '8px' }" @click="onClose(1)">
                    取消
                </a-button>
                <a-button type="primary" @click="goUpdateSupplierBasicDetail">
                    保存
                </a-button>
            </div>
    </div>
</template>
<script>

import {areaData} from "../../components/Data/data.js";
const KF = 'updatable';

export default {
    props:{
        suppliers:{
            type:Array
        }
    },
    components: {

    },
    data() {
        return {
            areaData:areaData,
            visible: false,
            form: this.$form.createForm(this),
            visibleEditSupplier: false,
            supplier:{},
            selectArea:[],
            selectPayWay:{key:"0", label:"请选择采购方式"},

        };
    },
    async created(){

    },
    methods: {
        editSupplier(){
            this.visibleEditSupplier = true;
            if(this.supplier.area != null){
                this.selectArea = this.supplier.area.split("/")
            }
            this.selectPayWay.key = this.supplier.pay_type
            this.selectPayWay.label = (this.supplier.pay_type ==0) ? "请选择采购方式" : this.supplier.pay_way
        },
        async goUpdateSupplierBasicDetail(){
            this.supplier.name = this.supplier.name.replace(/ /g, '');
            // console.log(this.supplier.name)
            if((this.supplier.name == "")||(this.supplier.name == null)){
                this.$notification['warning']({
                    message: '供应商名称不能为空！',
                    description:
                    '请填写供应商名称',
                });
                return;
            }
            let item = this.suppliers.find(it=>it.label == this.supplier.name)
            if(item != null){
                this.$notification['warning']({
                    message: '供应商名称已存在！',
                    description:
                    '请重新填写供应商名称',
                });
                return;
            }

            if(this.selectAreaItem != null){
                this.supplier.area = ""
                for(let item of this.selectAreaItem){
                    this.supplier.area = ((this.supplier.area == "")||(this.supplier.area == null)) ?  item.label : this.supplier.area + "/" +  item.label
                }
                this.supplier.province_code = this.selectAreaItem[0].code
                this.supplier.province_name = this.selectAreaItem[0].label
                this.supplier.district_code = this.selectAreaItem[1].code
                this.supplier.district_name = this.selectAreaItem[1].label
                this.supplier.city_code = this.selectAreaItem[2].code
                this.supplier.city_name = this.selectAreaItem[2].label
            }
            let rs = await this.$api.goUpdateSupplierBasicDetail(this.supplier)
            if(rs.err == 0){
                this.$message.success('保存成功')
                this.updateParam()
            }else{
               this.$message.warn('保存失败，请检查后重试或联系管理员')
            }
                
        },
        onClose(vis) {
            // console.log(vis);
            (vis == 0)?(this.visibleAddMaterial = false):this.visibleEditSupplier = false;
        },  
        handlePayWayChange(value){
            this.supplier.pay_type = value.key
        },
        onChange(value, code) {
            this.selectAreaItem = code
        },
        updateParam(){
            const newParam = {key:1, data:[]};
            this.$emit('update-param', newParam);
        }  
   
    },
};
</script>
<style scoped>
#components-form-demo-validate-other .dropbox {
    height: 180px;
    line-height: 1.5;
}
.editable-row-operations a {
    margin-right: 8px;
}

</style>